(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sk-packs"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.skPacksReady) return;
    window.skPacksReady = true;

    const quantityOf = (node) =>
      (node.closest('.product-details') || document).querySelector('input[name="quantity"]');

    // Pack prices follow the selected variant. The block ships every variant's prices, already rounded and
    // formatted by Liquid, so this only swaps text: no money formatting or rounding happens here.
    const tables = new WeakMap();
    const tableOf = (box) => {
      if (!tables.has(box)) {
        let rows = [];
        try {
          rows = JSON.parse(box.querySelector('[data-sk-pack-data]')?.textContent || '[]');
        } catch (error) {
          rows = [];
        }
        tables.set(box, rows);
      }
      return tables.get(box);
    };

    const selectedValues = (scope) => {
      const picker = scope.querySelector('variant-picker');
      if (!picker) return null;
      const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
      const values = fieldsets.length
        ? fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value)
        : Array.from(picker.querySelectorAll('select')).map((select) => select.value);
      return values.length && values.every((value) => typeof value === 'string') ? values : null;
    };

    const sync = (box) => {
      const values = selectedValues(box.closest('.product-details') || document);
      if (!values) return;
      const row = tableOf(box).find((item) => item.o.length === values.length && item.o.every((o, i) => o === values[i]));
      if (!row) return;
      const options = box.querySelectorAll('.sk-packs__option');
      row.t.forEach((tier, index) => {
        const option = options[index];
        if (!option) return;
        const unit = option.querySelector('[data-sk-unit]');
        const total = option.querySelector('[data-sk-total]');
        const full = option.querySelector('[data-sk-full]');
        if (unit) unit.textContent = tier[0];
        if (total) total.textContent = tier[1];
        if (full) full.textContent = tier[2];
      });
    };

    const syncAll = () => {
      for (const box of document.querySelectorAll('.sk-packs')) sync(box);
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      // A variant option was chosen: update now, and again once the theme has re-drawn the picker.
      if (target.closest('variant-picker')) {
        syncAll();
        window.setTimeout(syncAll, 450);
        return;
      }

      if (!(target instanceof HTMLInputElement)) return;

      if (target.matches('[data-sk-pack]')) {
        const quantity = quantityOf(target);
        if (!quantity) return;
        quantity.value = target.value;
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // Keep the picker honest when the stepper is used directly.
      if (target.name === 'quantity') {
        const box = target.closest('.product-details');
        if (!box) return;
        for (const pack of box.querySelectorAll('[data-sk-pack]')) {
          pack.checked = pack.value === target.value;
        }
      }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    else syncAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
